import { Head, useForm } from "@inertiajs/react"
import type { FormEvent } from "react"

import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { identityPasswordResetPath } from "@/routes"

interface ResetPasswordProps {
  sid: string
  email: string
}

export default function ResetPassword({ sid, email }: ResetPasswordProps) {
  const { data, setData, put, processing, errors, reset } = useForm({
    sid,
    email,
    password: "",
    password_confirmation: "",
  })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    put(identityPasswordResetPath(), {
      onSuccess: () => reset("password", "password_confirmation"),
    })
  }

  return (
    <AuthLayout
      title="Reset password"
      description="Please enter your new password below"
    >
      <Head title="Reset password" />
      <form onSubmit={submit}>
        <div className="grid gap-6">
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              value={data.email}
              className="mt-1 block w-full"
              readOnly
            />
            <InputError messages={errors.email} className="mt-2" />
          </div>

          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              className="mt-1 block w-full"
              autoFocus
              placeholder="Password"
              value={data.password}
              onChange={(e) => setData("password", e.target.value)}
            />
            <InputError messages={errors.password} />
          </div>

          <div className="grid gap-2">
            <Label htmlFor="password_confirmation">Confirm password</Label>
            <Input
              id="password_confirmation"
              type="password"
              autoComplete="new-password"
              className="mt-1 block w-full"
              placeholder="Confirm password"
              value={data.password_confirmation}
              onChange={(e) => setData("password_confirmation", e.target.value)}
            />
            <InputError
              messages={errors.password_confirmation}
              className="mt-2"
            />
          </div>

          <Button type="submit" className="mt-4 w-full" disabled={processing}>
            {processing && <Spinner />}
            Reset password
          </Button>
        </div>
      </form>
    </AuthLayout>
  )
}
